export const mobileBreakPoint = "md";

export const mobileDropDownWidth = "90%";
